import React, { useState } from 'react';
import { IntlProvider, MessageFormatElement } from 'react-intl';
import { AvailableLanguages, TranslationService } from '../services/TranslationService';
import messages_pt from "../translations/pt.json";

interface IntlContextProps {
    setLanguage: (language: AvailableLanguages) => void,
    language: AvailableLanguages,
}

const IntlContext = React.createContext<IntlContextProps>({
    setLanguage: () => { },
    language: "pt"
});

interface IntlProviderProps {
    children?: any
}

// Using a forced cast to resolve the type issue
const messages: {
    [key in AvailableLanguages]: Record<string, string>
} = {
    pt: messages_pt as any as Record<string, string>,
};

export const IntlProviderWrapper = (props: IntlProviderProps) => {

    const [currentLanguage, setCurrentLanguage] = useState<AvailableLanguages>(TranslationService.GetLanguage());

    const setLanguage = (language: AvailableLanguages) => {
        TranslationService.SetLanguage(language);
        setCurrentLanguage(language);
    }

    return (
        <IntlContext.Provider value={{ setLanguage: setLanguage, language: currentLanguage }}>
            <IntlProvider messages={messages[currentLanguage]} locale={currentLanguage} defaultLocale="pt">
                {props.children}
            </IntlProvider>
        </IntlContext.Provider>
    )
}
export const useMyIntl = () => React.useContext(IntlContext);
